var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { coreConfig, px2rem } from 'smartpi-core';
import styled from 'styled-components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 200;\n"], ["\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 200;\n"])));
var TipModalBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  margin: ", " auto 0;\n  width: ", ";\n"], ["\n  position: relative;\n  margin: ", " auto 0;\n  width: ", ";\n"])), px2rem(300), px2rem(560));
var TipModalTop = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  img {\n    width: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  img {\n    width: ", ";\n  }\n"])), px2rem(560), px2rem(70), px2rem(560));
var TipBox = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n  color: #666;\n  font-size: ", ";\n  text-align: center;\n  line-height: ", ";\n  background: #fff;\n"], ["\n  width: ", ";\n  color: #666;\n  font-size: ", ";\n  text-align: center;\n  line-height: ", ";\n  background: #fff;\n"])), px2rem(560), px2rem(26), px2rem(40));
var EmoticonBox = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background: #fff;\n"], ["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background: #fff;\n"])), px2rem(-35), px2rem(220), px2rem(120), px2rem(120));
var Shine = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  background: url(", ") no-repeat;\n  background-size: ", " ", ";\n"], ["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  background: url(", ") no-repeat;\n  background-size: ", " ", ";\n"])), px2rem(-150), px2rem(70), px2rem(420), px2rem(250), coreConfig.CDN_DOMAIN + "/h5/point/shine.png", px2rem(420), px2rem(250));
var EmoticonImg = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n"], ["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n"])), px2rem(-22), px2rem(236), px2rem(88), px2rem(88));
var EmoticonType;
(function (EmoticonType) {
    EmoticonType[EmoticonType["HAPPY"] = 0] = "HAPPY";
    EmoticonType[EmoticonType["SAID"] = 1] = "SAID";
    EmoticonType[EmoticonType["WAIT"] = 2] = "WAIT";
})(EmoticonType || (EmoticonType = {}));
var TipModalNoClose = /** @class */ (function (_super) {
    __extends(TipModalNoClose, _super);
    function TipModalNoClose(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(TipModalNoClose.prototype, "getEmoticon", {
        get: function () {
            var emoticonType = this.props.emoticonType;
            if (emoticonType === EmoticonType.SAID) {
                return coreConfig.CDN_DOMAIN + "/h5/point/said.png";
            }
            if (emoticonType === EmoticonType.WAIT) {
                return coreConfig.CDN_DOMAIN + "/h5/point/waite.png";
            }
            return coreConfig.CDN_DOMAIN + "/h5/point/happy.png";
        },
        enumerable: true,
        configurable: true
    });
    TipModalNoClose.prototype.render = function () {
        var isShowShine = this.props.isShowShine;
        return (React.createElement(Container, null,
            React.createElement(TipModalBox, null,
                React.createElement(EmoticonBox, null),
                isShowShine && React.createElement(Shine, null),
                React.createElement(EmoticonImg, { src: this.getEmoticon }),
                React.createElement(TipModalTop, null,
                    React.createElement("img", { src: coreConfig.CDN_DOMAIN + "/h5/point/modal_top_2.png" })),
                React.createElement(TipBox, null, this.props.children),
                React.createElement("img", { style: { width: "100%" }, src: coreConfig.CDN_DOMAIN + "/h5/point/modal_bottom_2.png" }))));
    };
    return TipModalNoClose;
}(Component));
export { TipModalNoClose };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TipModalNoClose.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/TipModalNoClose.js
// module id = 1061
// module chunks = 0